angular.module('impactx.cube').factory('cubeMenu', ['dataGen',
    '$securityManager',
    '$q',
    '$config',
    'ToastService',
    '$redirect',
    'DownloadService',
    cubeMenuFactory]);

function cubeMenuFactory(dataGen, $securityManager, $q, $config, ToastService, $redirect, DownloadService) {
    var self = this;
    this.actionTranslations = {};
    this.deletionTranslations = {};

    this.initData = function() {
        self.cubes = {label: "", subitems: [], showOpen: true};
    };

    this.clearData = function() {
        self.initData();
    };

    this.initData();

    this.refreshCubes = function() {
        if($securityManager.isProcessAllowed("CubeOrdering")) {
            var tempScope = {};
            return dataGen.getData(tempScope, {}, "/monitor/cube/stored/getmenu").then(function() {
                self.cubes.subitems = tempScope.data.subitems;
                self.cubes.label = tempScope.data.label;
                self.actionTranslations.exportExcel = tempScope.trns.exportExcel;
                self.actionTranslations.sendMail = tempScope.trns.sendMail;
                self.actionTranslations.displayCube = tempScope.trns.displayCube;
            });
        }
        else {
            self.clearData();
            return $q(function(resolve, reject) {
                reject();
            });
        }
    };

    this.getCubes = function() {
        return self.cubes;
    };

    this.exportCube = function(id) {
        DownloadService.openDownloadPost('/monitor/cube/stored/download/excel', {paramName: "id", paramValue: id});
    };

    this.sendCubeMail = function(id) {
        dataGen.getData({}, {id: id}, "/monitor/cube/stored/sendmail").then(function(data) {
            ToastService.openStandardToast(data.trns.mailSent);
        });
    };

    this.displayCube = function(id) {
        $redirect.redirectTo(null, "/cube/" + id);
    };

    return {
        clearData: this.clearData,
        refreshCubes: this.refreshCubes,
        getCubes: this.getCubes,
        exportCube: this.exportCube,
        sendCubeMail: this.sendCubeMail,
        deleteCube: this.deleteCube,
        displayCube: this.displayCube,
        actionTranslations: this.actionTranslations
    }
}